import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding-top: 10px;
`;

const WrestlerRow = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 14px 20px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 10px;
  cursor: default;
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: rgba(163, 27, 27, 0.5);
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.3);
    transform: translateY(-2px);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, transparent 0%, rgba(163, 27, 27, 0.5) 40%, rgba(163, 27, 27, 0.5) 60%, transparent 100%);
  }
`;

const Position = styled.div<{ $rank: number }>`
  font-size: 22px;
  font-weight: 800;
  min-width: 40px;
  text-align: center;
  color: ${({ $rank }) =>
    $rank === 1 ? 'gold' :
    $rank === 2 ? '#c0c0c0' :
    $rank === 3 ? '#cd7f32' :
    'rgba(255,255,255,0.35)'};
  flex-shrink: 0;
`;

const Avatar = styled.div`
  width: 72px;
  height: 72px;
  border: 2px solid rgba(163, 27, 27, 0.4);
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
    display: block;
  }

  &:hover {
    border-color: rgba(163, 27, 27, 0.85);
    transform: scale(1.06);
    box-shadow: 0 0 10px rgba(163, 27, 27, 0.25);
  }
`;

const Name = styled.div`
  flex: 1;
  font-size: 17px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Stats = styled.div`
  display: flex;
  flex-direction: row;
  gap: 28px;
  flex-shrink: 0;
`;

const StatBox = styled.div<{ $highlight?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;

  .stat-label {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: rgba(255, 255, 255, 0.4);
  }

  .stat-value {
    font-size: 24px;
    font-weight: 800;
    color: ${({ $highlight }) => $highlight ? 'rgba(255, 215, 0, 0.9)' : 'rgba(255,255,255,0.75)'};
    line-height: 1;
  }
`;

const ContainerListWrestlersComponent = ({ listWrestlers, navigateToWrestler, beforeFights }) => {
  return (
    <Container className="container-list-wrestlers-component">
      {listWrestlers.map((wrestler, key) => (
        <WrestlerRow key={key}>
          <Position $rank={wrestler.position}>{wrestler.position}</Position>

          <Avatar onClick={() => navigateToWrestler(wrestler)}>
            <img
              src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path}
              alt={wrestler.name}
            />
          </Avatar>

          <Name>{wrestler.name}</Name>

          <Stats>
            {beforeFights ? (
              <>
                <StatBox $highlight>
                  <span className="stat-label">Fights</span>
                  <span className="stat-value">{wrestler.fights_count}</span>
                </StatBox>
                <StatBox>
                  <span className="stat-label">Wins</span>
                  <span className="stat-value">{wrestler.wins_count}</span>
                </StatBox>
              </>
            ) : (
              <>
                <StatBox $highlight>
                  <span className="stat-label">Wins</span>
                  <span className="stat-value">{wrestler.wins_count}</span>
                </StatBox>
                <StatBox>
                  <span className="stat-label">Fights</span>
                  <span className="stat-value">{wrestler.fights_count}</span>
                </StatBox>
              </>
            )}
          </Stats>
        </WrestlerRow>
      ))}
    </Container>
  );
};

export default ContainerListWrestlersComponent;
